/**
 * Cart page AJAX — qty, remove, clear, section refresh, header count.
 * Ship+ logic stays in cart-insurance.js; variant ID comes from cart.liquid.
 */
window.OWCartPageAjax = window.OWCartPageAjax || (function () {
  var isUpdating = false;
  var cartLoadingLocks = 0;
  var subtotalLoadingLocks = 0;
  var cartSectionRefreshGeneration = 0;
  var qtySubmitTimer = null;
  var QTY_DEBOUNCE_MS = 500;

  var UI_TOGGLE_SELECTOR = '.read-shoppay, .read-shipping, .read-warranty, .read-remove, .close-me, .qty-badge';

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path.replace(/^\//, '');
  }

  function getCartEl() {
    return document.getElementById('cart');
  }

  function setCartBusy(busy) {
    var cart = getCartEl();
    if (!cart) return;

    cart.classList.toggle('is-updating', busy);
    cart.setAttribute('aria-busy', String(busy));
  }

  function applyLoadingUi() {
    var cartLoading = cartLoadingLocks > 0;
    var subtotalLoading = cartLoading || subtotalLoadingLocks > 0;
    var subtotal = document.querySelector('#cart .checkout-cart-summary--sub-total--display-price');
    var insuranceCost = document.querySelector('#cart #insurance-cost');
    var summary = document.querySelector('#cart #checkout-cart-summary');

    summary?.setAttribute('aria-busy', String(subtotalLoading));
    subtotal?.classList.toggle('is-loading', subtotalLoading);
    var shipPlusOnlyBusy = window.OWShipPlus?.isInsuranceBusy?.();
    insuranceCost?.classList.toggle('is-loading', cartLoading && !shipPlusOnlyBusy);
  }

  function setCartLoadingState(loading) {
    cartLoadingLocks += loading ? 1 : -1;
    if (cartLoadingLocks < 0) cartLoadingLocks = 0;
    applyLoadingUi();
  }

  function setSubtotalLoadingState(loading) {
    subtotalLoadingLocks += loading ? 1 : -1;
    if (subtotalLoadingLocks < 0) subtotalLoadingLocks = 0;
    applyLoadingUi();
  }

  function parseJsonResponse(response) {
    return response.json().catch(function () { return {}; });
  }

  function postJson(path, body) {
    return fetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      credentials: 'same-origin',
      body: JSON.stringify(body || {})
    }).then(parseJsonResponse);
  }

  function postFormEncoded(path, body) {
    var params = new URLSearchParams();
    Object.keys(body || {}).forEach(function (key) {
      params.append(key, body[key]);
    });

    return fetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      credentials: 'same-origin',
      body: params.toString()
    }).then(parseJsonResponse);
  }

  function fetchCartJson() {
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(parseJsonResponse);
  }

  function fetchCartSectionHtml() {
    return fetch(cartUrl('cart?section_id=cart'), { credentials: 'same-origin' })
      .then(function (response) { return response.text(); });
  }

  function getCartChangeParams(href) {
    var url = new URL(href, window.location.origin);
    var quantity = url.searchParams.get('quantity');

    return {
      id: url.searchParams.get('id'),
      quantity: quantity === null ? null : Number(quantity)
    };
  }

  function getVisibleCartCount(cart) {
    if (window.OWShipPlus && typeof window.OWShipPlus.getRealCartItemCount === 'function') {
      return window.OWShipPlus.getRealCartItemCount(cart);
    }

    return cart.items.reduce(function (count, item) {
      return count + item.quantity;
    }, 0);
  }

  function getCurrentHeaderCartCount() {
    var cartCount = document.querySelector('.cart-count');
    return cartCount ? parseInt(cartCount.textContent, 10) || 0 : 0;
  }

  function renderHeaderCartCount(count) {
    document.querySelectorAll('.cart-frame').forEach(function (cartFrame) {
      var cartCount = cartFrame.querySelector('.cart-count');

      if (count <= 0) {
        cartCount?.remove();
        return;
      }

      if (!cartCount) {
        cartCount = document.createElement('span');
        cartCount.className = 'cart-count';
        cartFrame.appendChild(cartCount);
      }

      cartCount.textContent = count;
      cartCount.classList.toggle('tight', count > 9);
    });
  }

  function optimisticallyUpdateHeaderCartCount(delta) {
    renderHeaderCartCount(Math.max(0, getCurrentHeaderCartCount() + delta));
  }

  function refreshHeaderCartCount() {
    return fetchCartJson().then(function (cart) {
      renderHeaderCartCount(getVisibleCartCount(cart));
    });
  }

  function syncShipPlusPropsFromHtml(html) {
    var match = html.match(/['"]__preTaxPrice['"]\s*:\s*([0-9.]+)/);
    if (match) {
      window.__shipPlusScpProps = { '__preTaxPrice': Number(match[1]) };
    }
  }

  function syncShipPlusPropsFromCart(cart) {
    if (!cart || !cart.items) return;

    if (window.OWShipPlus?.rememberCart) {
      window.OWShipPlus.rememberCart(cart);
    }

    var insuranceItem = window.OWShipPlus && window.OWShipPlus.getInsuranceItem(cart);
    var preTaxCents = 0;

    cart.items.forEach(function (item) {
      if (insuranceItem && item.key === insuranceItem.key) return;
      preTaxCents += item.final_line_price;
    });

    window.__shipPlusScpProps = { '__preTaxPrice': preTaxCents / 100 };
  }

  function isCartPayload(value) {
    return Boolean(value && Array.isArray(value.items));
  }

  function beginCartSectionRefresh() {
    cartSectionRefreshGeneration += 1;
    return cartSectionRefreshGeneration;
  }

  function isCurrentCartSectionRefresh(generation) {
    return generation === cartSectionRefreshGeneration;
  }

  function replaceFromSectionHtml(html, selectors) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    selectors.forEach(function (selector) {
      var fresh = doc.querySelector(selector);
      var current = document.querySelector(selector);

      if (fresh && current) {
        current.replaceWith(fresh);
      }
    });
  }

  function syncShopPayFromSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshListItem = doc.querySelector('li.klarna-p');
    var currentListItem = document.querySelector('li.klarna-p');
    var list = document.querySelector('.checkout-disclaimers ul');

    if (freshListItem && currentListItem) {
      currentListItem.replaceWith(freshListItem);
      return;
    }

    if (freshListItem && !currentListItem && list) {
      list.appendChild(freshListItem);
      return;
    }

    if (!freshListItem && currentListItem) {
      currentListItem.remove();
    }
  }


  function afterInsuranceOnlyChange(cart) {
    if (isCartPayload(cart)) {
      syncShipPlusPropsFromCart(cart);
    }

    return fetchCartSectionHtml()
      .then(function (html) {
        if (!html) return;

        syncShipPlusPropsFromHtml(html);
        replaceFromSectionHtml(html, [
          '.ow-ship',
          '.checkout-cart-summary--sub-total--display-price'
        ]);
        syncShopPayFromSectionHtml(html);
      })
      .then(function () {
        if (isCartPayload(cart)) {
          renderHeaderCartCount(getVisibleCartCount(cart));
          return;
        }

        return refreshHeaderCartCount();
      })
      .then(function () {
        if (window.OWShipPlus?.setToggleEnabled && !window.OWShipPlus.isInsuranceBusy()) {
          window.OWShipPlus.setToggleEnabled(true);
        }
      });
  }

  function replaceCartSection(html, generation) {
    if (generation !== undefined && !isCurrentCartSectionRefresh(generation)) {
      return false;
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshCart = doc.getElementById('cart');
    var currentCart = getCartEl();
    var freshCartContent = freshCart?.querySelector('#checkout-cart--cart');

    if (!freshCart || !currentCart) return false;

    if (freshCartContent?.querySelector('tr.bundle-upsell')) {
      freshCartContent.classList.add('show-bundle-cross');
    }

    currentCart.replaceWith(freshCart);

    if (isUpdating) {
      setCartBusy(true);
      applyLoadingUi();
    }

    return true;
  }

  function reconcileShipPlus(cart) {
    var options = { suppressUi: true };

    if (isCartPayload(cart)) {
      options.cart = cart;
    }

    if (window.OWShipPlus?.runInsuranceCheck) {
      return window.OWShipPlus.runInsuranceCheck(options);
    }

    return Promise.resolve(false);
  }

  function afterCartChange(cart, options) {
    options = options || {};

    if (options.insuranceOnly) {
      return afterInsuranceOnlyChange(cart);
    }

    var refreshGeneration = beginCartSectionRefresh();
    var latestCart = isCartPayload(cart) ? cart : null;

    if (latestCart) {
      syncShipPlusPropsFromCart(latestCart);
    }

    return reconcileShipPlus(latestCart)
      .then(function (insuranceChanged) {
        if (!isCurrentCartSectionRefresh(refreshGeneration)) return;

        if (!insuranceChanged || !latestCart) return;

        return fetchCartJson().then(function (freshCart) {
          if (!isCurrentCartSectionRefresh(refreshGeneration)) return;
          latestCart = freshCart;
          syncShipPlusPropsFromCart(latestCart);
        });
      })
      .then(function () {
        if (!isCurrentCartSectionRefresh(refreshGeneration)) return;
        return fetchCartSectionHtml();
      })
      .then(function (html) {
        if (!isCurrentCartSectionRefresh(refreshGeneration) || !html) return;

        syncShipPlusPropsFromHtml(html);
        replaceCartSection(html, refreshGeneration);
      })
      .then(function () {
        if (!isCurrentCartSectionRefresh(refreshGeneration)) return;

        if (latestCart) {
          renderHeaderCartCount(getVisibleCartCount(latestCart));
          return;
        }

        return refreshHeaderCartCount();
      })
      .then(function () {
        if (window.OWShipPlus?.setToggleEnabled && !window.OWShipPlus.isInsuranceBusy()) {
          window.OWShipPlus.setToggleEnabled(true);
        }
      });
  }

  function runCartUpdate(operation, options) {
    if (isUpdating) {
      return Promise.reject(new Error('Cart update already in progress'));
    }

    isUpdating = true;
    setCartLoadingState(true);
    setCartBusy(true);

    return Promise.resolve()
      .then(operation)
      .then(function (cart) {
        return afterCartChange(cart, options);
      })
      .finally(function () {
        isUpdating = false;
        setCartLoadingState(false);
        setCartBusy(false);
      });
  }

  function changeByUrl(href) {
    var params = getCartChangeParams(href);

    if (!params.id || params.quantity === null) {
      return Promise.reject(new Error('Missing cart line update parameters.'));
    }

    return postJson('cart/change.js', { id: params.id, quantity: params.quantity });
  }

  function changeLineQuantity(lineKey, quantity) {
    return postJson('cart/change.js', { id: lineKey, quantity: quantity });
  }

  function updateLinesToZero(keys) {
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    return postJson('cart/update.js', { updates: updates });
  }

  function submitCartForm(form) {
    var params = new URLSearchParams(new FormData(form));
    params.delete('checkout');

    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      credentials: 'same-origin',
      body: params.toString()
    }).then(parseJsonResponse);
  }

  function handleCartUpdateFailure(error, fallbackHref) {
    console.error('Cart update failed:', error);

    if (fallbackHref) {
      window.location.assign(fallbackHref);
      return;
    }

    window.location.reload();
  }

  function optimisticallyRemoveLine(trigger) {
    var group = trigger.closest('tbody.bundle-group, tr.bundle-group');
    if (!group) return;

    var table = group.closest('table.cart-items-table');
    group.remove();

    if (!table || !table.isConnected || table.querySelector('tbody.bundle-group, tr.bundle-group')) {
      return;
    }

    var label = table.previousElementSibling;
    table.remove();

    if (label && label.classList.contains('tab-label')) {
      label.remove();
    }
  }

  function findQtyBadgeTextNode(badge) {
    return Array.prototype.find.call(badge.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '';
    });
  }

  function setQtyBadgeText(badge, quantity) {
    if (!badge) return;

    var textNode = findQtyBadgeTextNode(badge);
    if (textNode) {
      textNode.nodeValue = textNode.nodeValue.replace(/\S+/, quantity);
    } else {
      badge.insertBefore(document.createTextNode(quantity), badge.firstChild);
    }
  }

  function getQtyBadgeValue(badge) {
    if (!badge) return 0;
    var textNode = findQtyBadgeTextNode(badge);
    return parseInt(textNode?.nodeValue, 10) || 0;
  }

  function optimisticallyUpdateQuantity(trigger, quantity) {
    if (!quantity) return;

    var row = trigger.closest('tr');
    var quantityMenu = trigger.closest('.toggle-quantity');
    var activeBadge = quantityMenu?.closest('.qty-badge');
    var priceTotal = row?.querySelector('.price-total');
    var oldQuantity = parseInt(row?.getAttribute('data-qty'), 10) || getQtyBadgeValue(activeBadge);

    if (row) {
      row.setAttribute('data-qty', String(quantity));
      setQtyBadgeText(row.querySelector('.qty-badge.show-small'), quantity);
    }

    optimisticallyUpdateHeaderCartCount(quantity - oldQuantity);
    setQtyBadgeText(activeBadge, quantity);
    activeBadge?.classList.remove('active');
    quantityMenu?.classList.remove('show');
    row?.classList.remove('qty-menu-open');

    quantityMenu?.querySelectorAll('a').forEach(function (link) {
      var linkHref = link.getAttribute('href');
      var linkQuantity = linkHref
        ? getCartChangeParams(linkHref).quantity
        : Number(link.textContent.trim());
      link.classList.toggle('strong', linkQuantity === quantity);
    });

    priceTotal?.classList.add('is-loading');
  }

  function scheduleCartFormSubmit() {
    clearTimeout(qtySubmitTimer);
    qtySubmitTimer = setTimeout(function () {
      var form = document.getElementById('cartform');
      if (!form || isUpdating) return;

      runCartUpdate(function () {
        return submitCartForm(form);
      }).catch(handleCartUpdateFailure);
    }, QTY_DEBOUNCE_MS);
  }

  function adjustQtyInput(input, delta) {
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 0;
    value = Math.max(0, value + delta);
    input.value = value;
    scheduleCartFormSubmit();
  }

  function isCheckoutSubmitter(submitter) {
    if (!submitter) return false;
    return submitter.name === 'checkout' || Boolean(submitter.closest?.('.mobile-frame-checkout'));
  }

  function isCartMutationInteraction(target) {
    if (!(target instanceof Element) || !target.closest('#cart')) {
      return false;
    }

    if (target.closest(UI_TOGGLE_SELECTOR)) {
      return false;
    }

    return Boolean(
      target.closest('.clear-cart, .bundle-remove-link, .toggle-quantity a, .qtyplus, .qtyminus, .line-variant-switcher select') ||
      target.closest('input[name="checkout"], button[name="checkout"], .cart-page--checkout-button, .mobile-frame-checkout') ||
      (target.matches('input[id^="updates"]') && target.closest('#cartform'))
    );
  }

  function swapVariant(wrap, newVariantId) {
    var lineKey = wrap.getAttribute('data-line-key');
    var currentVariantId = wrap.getAttribute('data-current-variant');
    var quantity = parseInt(wrap.getAttribute('data-qty'), 10) || 1;
    var status = wrap.querySelector('.switcher-status');
    var properties = {};

    if (String(newVariantId) === String(currentVariantId)) {
      return;
    }

    try {
      properties = JSON.parse(wrap.getAttribute('data-props') || '{}') || {};
    } catch (error) {
      properties = {};
    }

    if (status) {
      status.hidden = false;
      status.textContent = 'Updating…';
    }

    runCartUpdate(function () {
      return postFormEncoded('cart/change.js', { id: lineKey, quantity: 0 })
        .then(function () {
          return postJson('cart/add.js', {
            id: Number(newVariantId),
            quantity: quantity,
            properties: properties
          });
        });
    }).catch(function () {
      if (status) {
        status.textContent = 'Sorry—couldn’t update. Try again.';
      }
    });
  }

  function handleBundleRemove(btn) {
    var keys = (btn.getAttribute('data-bundle-keys') || '').split('|').filter(Boolean);
    var updateKeys = keys.slice();
    var removeBoth = btn.getAttribute('data-remove-both') === '1';
    var boardKey = btn.getAttribute('data-board-key');

    if (removeBoth && boardKey) {
      updateKeys.push(boardKey);
    }

    if (!keys.length && !(removeBoth && boardKey)) {
      var href = btn.getAttribute('href');
      if (!href) return;

      runCartUpdate(function () {
        return changeByUrl(href);
      }).catch(function (error) {
        handleCartUpdateFailure(error, href);
      });
      return;
    }

    runCartUpdate(function () {
      return updateLinesToZero(updateKeys);
    }).catch(handleCartUpdateFailure);
  }

  function initEventHandlers() {
    document.addEventListener('click', function (event) {
      if (!isUpdating || !isCartMutationInteraction(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      var target = event.target;

      if (target.closest('.read-shoppay')) {
        document.querySelector('.show-shoppay')?.classList.toggle('hide');
        return;
      }

      if (target.closest('.read-shipping')) {
        document.querySelector('.show-shipping')?.classList.toggle('hide');
        return;
      }

      if (target.closest('.read-warranty')) {
        document.querySelector('.show-warranty')?.classList.toggle('hide');
        return;
      }

      if (target.closest('.close-me')) {
        document.querySelectorAll('.read-remove.show-more').forEach(function (el) {
          el.classList.remove('show-more');
        });
        return;
      }

      if (target.closest('.read-remove')) {
        target.closest('.read-remove')?.classList.toggle('show-more');
        document.querySelectorAll('.qty-badge.active').forEach(function (badge) {
          badge.classList.remove('active');
        });
        document.querySelectorAll('#cart .toggle-quantity.show').forEach(function (menu) {
          menu.classList.remove('show');
        });
        document.querySelectorAll('#cart tr.qty-menu-open').forEach(function (row) {
          row.classList.remove('qty-menu-open');
        });
        return;
      }

      var clearCart = target.closest('.clear-cart');
      if (clearCart) {
        event.preventDefault();
        var clearHref = clearCart.getAttribute('href') || '/cart/clear';

        runCartUpdate(function () {
          return postJson('cart/clear.js');
        }).catch(function (error) {
          handleCartUpdateFailure(error, clearHref);
        });
        return;
      }

      var bundleRemove = target.closest('.bundle-remove-link');
      if (bundleRemove) {
        event.preventDefault();
        optimisticallyRemoveLine(bundleRemove);
        handleBundleRemove(bundleRemove);
        return;
      }

      var dataQtyLink = target.closest('.toggle-quantity a[data-q]');
      if (dataQtyLink) {
        event.preventDefault();
        var lineKey = dataQtyLink.getAttribute('data-line-key');
        var qty = parseInt(dataQtyLink.getAttribute('data-q'), 10) || 1;

        optimisticallyUpdateQuantity(dataQtyLink, qty);
        runCartUpdate(function () {
          return changeLineQuantity(lineKey, qty);
        }).catch(handleCartUpdateFailure);
        return;
      }

      var quantityLink = target.closest('.toggle-quantity a.cart.remove-link');
      if (quantityLink) {
        event.preventDefault();
        var quantityHref = quantityLink.getAttribute('href');

        optimisticallyUpdateQuantity(quantityLink, getCartChangeParams(quantityHref).quantity);
        runCartUpdate(function () {
          return changeByUrl(quantityHref);
        }).catch(function (error) {
          handleCartUpdateFailure(error, quantityHref);
        });
        return;
      }

      var qtyBadge = target.closest('.qty-badge');
      if (qtyBadge && qtyBadge.closest('#cart') && !target.closest('.toggle-quantity a')) {
        event.preventDefault();
        var qtyRow = qtyBadge.closest('tr');
        var wasActive = qtyBadge.classList.contains('active');

        document.querySelectorAll('#cart .toggle-quantity.show').forEach(function (menu) {
          menu.classList.remove('show');
        });
        document.querySelectorAll('#cart .qty-badge.active').forEach(function (badge) {
          badge.classList.remove('active');
        });
        document.querySelectorAll('#cart tr.qty-menu-open').forEach(function (row) {
          row.classList.remove('qty-menu-open');
        });

        if (!wasActive) {
          qtyBadge.querySelectorAll('span').forEach(function (span) {
            span.classList.add('show');
          });
          qtyBadge.classList.add('active');
          qtyRow?.classList.add('qty-menu-open');
        }
        return;
      }

      var qtyPlus = target.closest('.qtyplus');
      if (qtyPlus) {
        event.preventDefault();
        var plusInput = document.getElementById(qtyPlus.getAttribute('field'));
        if (plusInput) adjustQtyInput(plusInput, 1);
        return;
      }

      var qtyMinus = target.closest('.qtyminus');
      if (qtyMinus) {
        event.preventDefault();
        var minusInput = document.getElementById(qtyMinus.getAttribute('field'));
        if (minusInput) adjustQtyInput(minusInput, -1);
      }
    });

    document.addEventListener('input', function (event) {
      if (!(event.target instanceof HTMLInputElement)) return;
      if (!event.target.matches('#cart input[id^="updates"]')) return;
      scheduleCartFormSubmit();
    });

    document.addEventListener('change', function (event) {
      var select = event.target.closest?.('.line-variant-switcher .switcher-select');
      if (!select || isUpdating) return;

      var wrap = select.closest('.line-variant-switcher');
      var variantId = select.value;
      if (!variantId || select.options[select.selectedIndex]?.disabled) return;

      select.disabled = true;
      swapVariant(wrap, variantId);
    });

    document.addEventListener('submit', function (event) {
      if (event.target?.id !== 'cartform') return;

      var submitter = event.submitter || document.activeElement;
      if (isCheckoutSubmitter(submitter)) return;

      if (isUpdating) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      runCartUpdate(function () {
        return submitCartForm(event.target);
      }).catch(handleCartUpdateFailure);
    });
  }

  initEventHandlers();

  return {
    afterCartChange: afterCartChange,
    changeByUrl: changeByUrl,
    changeLineQuantity: changeLineQuantity,
    isCartUpdating: function () { return isUpdating; },
    optimisticallyRemoveLine: optimisticallyRemoveLine,
    optimisticallyUpdateQuantity: optimisticallyUpdateQuantity,
    refreshHeaderCartCount: refreshHeaderCartCount,
    runCartUpdate: runCartUpdate,
    setLoadingState: setCartLoadingState,
    setSubtotalLoadingState: setSubtotalLoadingState,
    updateLinesToZero: updateLinesToZero
  };
})();